<template>
  <div class="modal-SOSSet">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">订单详情</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>

      <div class="modal-body">
        <template>
          <el-table :data="tableData" :height="th" border style="width: 100%; max-height: 500px ;overflow-y: auto">

            <el-table-column prop="goodsName"  label="商品名称"></el-table-column>
            <el-table-column prop="number" label="购买数量" ></el-table-column>
            <el-table-column prop="goodsPrice" label="购买单价" ></el-table-column>
            <el-table-column prop="price" :formatter="getPrice" label=总价 ></el-table-column>

          </el-table>

        </template>
      </div>
    </div>


  </div>
</template>

<script>


import { timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "OrderInfo",
  data() {
    return {
      businessCode:'',
      pageIndex:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      orderCode:'',

    }
  },
  components: {

  },

  methods: {
    init(row) {
      this.businessCode=row.businessCode;
      this.orderCode=row.orderCode;
      this.getOrderInfo();
    },
    closeSelf() {
      this.$emit("closeOrderInfo");
    },

    getOrderInfo(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusiness/GetOrderInfo",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          orderCode:this.orderCode
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.tableData=response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },
    getPrice(row){
      return row.goodsPrice*row.number
    }




  }


}
</script>

<style lang="scss" scoped>

.modal-SOSSet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px;
      z-index: 99;

    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}

</style>